import { isMobile } from "react-device-detect";
//@ts-ignore
import { tw } from "@careinfo/tailwind";

const classNames = (...classes: any) => {
  return classes.filter(Boolean).join(" ");
};

function blurEmail(email: string): string {
  const [localPart, domain] = email.split("@");
  const visibleChars = 2; // Number of characters to show before the blur

  if (localPart.length <= visibleChars) {
    return email.replace(/.(?=.*@)/g, "*");
  }

  const blurredLocalPart = `${localPart.slice(0, visibleChars)}${"*".repeat(
    localPart.length - visibleChars
  )}`;
  return `${blurredLocalPart}@${domain}`;
}

const responsiveClassName = (
  mobileClassName: string,
  desktopClassName: string | null
) => {
  if (isMobile) {
    return tw`${mobileClassName}`;
  } else {
    return tw`${desktopClassName ? desktopClassName : mobileClassName}`;
  }
};

export { classNames, blurEmail, responsiveClassName };
